module.exports = __webpack_public_path__ + "static/media/evollis_logo.90990c44.png";